import React from 'react'
import dayjs from 'dayjs'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Typography from '@mui/material/Typography'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import LabelPopover from '@/javascript/presentation/components/inputs/label-popover'
import { useRoutingContext } from '../../hooks/use-routing-context'

export const WorkingHoursInput: React.FC = () => {
  const {
    date,
    workingHours: { startTime, startTimeError, endTime, endTimeError },
    setWorkingHours
  } = useRoutingContext()


  const startErrorMsg = () => {
    if (startTime.isAfter(endTime)) return `Deve ser antes de ${endTime.format('HH:mm')}`

    switch (startTimeError) {
      case 'disablePast':
      case 'minTime': {
        return `Deve ser igual ou após o horário atual ${dayjs().format('HH:mm')}`
      }
      case 'maxTime': {
        return `Deve ser antes do horário de fim ${endTime.format('HH:mm')}`
      }
      default: {
        return " "
      }
    }
  }

  const endErrorMsg = () => {
    switch (endTimeError) {
      case 'disablePast': {
        return `Deve ser igual ou após à data de hoje ${dayjs().format('DD/MM/YYYY')}`
      }
      case 'minTime': {
        return endTime.isSame(dayjs().hour(0).minute(0), 'minute')
          ? 'Deve ser igual ou anterior às 23:59'
          : `Deve ser após ${startTime.format('HH:mm')}`
      }
      default: {
        return " "
      }
    }
  }

  return (
    <FormControl required sx={{ display: 'flex', justifyContent: 'center' }}>
      <LabelPopover
        label="Jornada de trabalho"
        tooltipText="O sistema utilizará esse período para organizar e distribuir automaticamente as atividades selecionadas entre os executores selecionados."
      />
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2 }}>
        <TimePicker
          label="Início"
          value={startTime}
          slotProps={{
            actionBar: { actions: ['accept'] },
            textField: {
              helperText: startErrorMsg(),
              inputProps: { 'data-testid': 'wh-start-time-input' },
              error: Boolean(startTimeError) || startTime.isAfter(endTime)
            },
          }}
          minTime={dayjs().isSame(date, 'day') ? dayjs().subtract(1, 'minute') : undefined}
          shouldDisableTime={() => false}
          onChange={(newValue) => newValue && setWorkingHours(prev => ({ ...prev, startTime: newValue }))}
          onError={(error) => setWorkingHours(prev => ({ ...prev, startTimeError: error || "" }))}
        />
        <Typography>—</Typography>
        <TimePicker
          label="Fim"
          value={endTime}
          minTime={startTime?.add(5, 'minute')}
          slotProps={{
            actionBar: { actions: ['accept'] },
            textField: {
              helperText: endErrorMsg(),
              inputProps: { 'data-testid': 'wh-end-time-input' },
            },
          }}
          onChange={(newValue) => newValue && setWorkingHours(prev => ({ ...prev, endTime: newValue }))}
          onError={(error) => setWorkingHours(prev => ({ ...prev, endTimeError: error || "" }))}
        />
      </Box>
    </FormControl>
  )
}

export default WorkingHoursInput
